import commonPostTypeConfig from '../../common/postTypes/profession'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'profession',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
